import { Component, Inject, OnInit } from '@angular/core';
import { SabloaneService } from 'src/app/components/sabloane/sabloane.service';
import { helper } from 'src/environments/helper';
import { DashboardService } from '../../dashboard.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-info-documente-sabloane',
    templateUrl: './info-documente-sabloane.component.html',
    styleUrls: ['./info-documente-sabloane.component.scss']
})
export class InfoDocumenteSabloaneComponent implements OnInit {
    isLoading = false;
    helper = helper;
    sabloaneData: any[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            section: string
        },
        private dialogRef: MatDialogRef<InfoDocumenteSabloaneComponent>,
        private sabloaneService: SabloaneService,
        private dashboardService: DashboardService
    ) { }

    ngOnInit(): void {
        this.getSabloane();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    getSabloane() {
        this.isLoading = true;
        this.sabloaneService
            .getSabloane()
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe((response: any) => {
                this.sabloaneData = response.data;
            });
    }

    sendSablonContent(sablonContent: string) {
        this.dashboardService.sendSablonContent(sablonContent, this.data.section);
        this.closeDialog();
    }
}
